var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockFastForward = function SvgClockFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m34.05 17.25-3 3-3-3m3.368 2.25q.081-.739.082-1.5c0-7.456-6.044-13.5-13.5-13.5S4.5 10.544 4.5 18 10.544 31.5 18 31.5c4.24 0 8.025-1.956 10.5-5.014M18 10.5V18l4.5 3"
  })));
};
export default SvgClockFastForward;